<template>
  <div class="feeConfigList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId" @change="getListHouse" disabled>
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="zero"></el-option>
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchFeeName"
            :placeholder="$t('lang.lab_feeName')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" v-if="isFeeManager===1" @click="add">{{$t('lang.btn_addfeeConfig')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="configId" :label="$t('lang.lab_configId')" v-if="false"></el-table-column>
        <el-table-column prop="feeTypeCdName" :label="$t('lang.lab_feeTypeCdName')"></el-table-column>
        <el-table-column prop="nccCode" label="NCC编码" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="feeName" :label="$t('lang.lab_feeName')"></el-table-column>
        <el-table-column prop="feeFlagName" :label="$t('lang.lab_feeFlagName')"></el-table-column>
        <!-- <el-table-column prop="paymentCd" :label="$t('lang.lab_paymentCd')">
          <template slot-scope="scope">
            <span v-if="scope.row.paymentCd === '1200'">{{'预付费'}}</span>
            <span v-else>{{'后付费'}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="billTypeName" :label="$t('lang.lab_billTypeName')"></el-table-column>
        <el-table-column prop="paymentCycle" :label="$t('lang.lab_paymentCycle')" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.paymentCycle}}月</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="startTime" :label="$t('lang.lab_startTime')">
          <template slot-scope="scope">{{ scope.row.startTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('lang.lab_endTimes')">
          <template slot-scope="scope">{{ scope.row.endTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column prop="squarePrice" :label="$t('lang.lab_squarePrice')">
          <template
            slot-scope="scope"
          >{{scope.row.computingFormula == '2002' ? '-':scope.row.squarePrice+'元'}}</template>
        </el-table-column>
        <el-table-column
          prop="additionalAmount"
          :label="$t('lang.lab_additionalAmount')"
        ></el-table-column>
        <el-table-column prop="discountRate" label="折扣率" min-width="90">
          <template slot-scope="scope">
            {{ scope.row.discountRate !== '' && scope.row.discountRate !== null && scope.row.discountRate !== undefined ? scope.row.discountRate : '0' }}
          </template>
        </el-table-column>
        <el-table-column prop="discountTime" label="折扣年份" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.discountTime !== '' && scope.row.discountTime !== null && scope.row.discountTime !== undefined ? scope.row.discountTime : '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="isFeeManager===1" width="150" prop="operation" :label="$t('lang.lab_operation')">
          <template slot-scope="scope">
            <el-button  @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" v-if="isFeeManager===1" @click="deletetable(scope.row.configId)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :title="title"
      :visible.sync="isPopupPage"
      :close-on-click-modal="false"
      center
      top="5px !important"
      width="800px"
      @closed="handleDialogClosed"
    >
      <el-form
        :model="diaForm"
        :rules="rules"
        ref="diaForm"
        :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!-- 所属小区 -->
        <el-form-item :label="$t('lang.diaFormgarden')" prop="gardenFeeId">
          <el-select
            v-model="diaForm.gardenId"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')"
            class="select"
          >
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.diaFormgarden')" value></el-option>
            <el-option
              v-for="item in gardenDialist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 收费类型 -->
        <el-form-item :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCd">
          <el-select
            v-model="diaForm.feeTypeCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')"
            class="select"
          >
            <el-option
              key="0"
              :label="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')"
              value
            ></el-option>
            <el-option
              v-for="item in feeTypeList"
              :key="item.status_cd"
              :label="item.name"
              :value="item.status_cd"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="NCC编码" prop="nccCode">
          <el-input
            placeholder="请输入NCC编码"
            v-model="diaForm.nccCode"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_feeName')" prop="feeName">
          <el-input
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_feeName')"
            v-model="diaForm.feeName"
          ></el-input>
        </el-form-item>
        <!-- 收费项标识 -->
        <el-form-item :label="$t('lang.lab_feeFlagName')" prop="feeFlag" >
          <el-select
            class="select"
            v-model="diaForm.feeFlag"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeFlagName')"
            disabled
          >
            <el-option
              key="0"
              :label="$t('lang.lab_please_Select')+$t('lang.lab_feeFlagName')"
              value
            ></el-option>
            <el-option :label="$t('lang.cycle')" key="1" value="1003006"></el-option>
            <el-option :label="$t('lang.once')" key="2" value="2006012"></el-option>
            <el-option :label="$t('lang.repeatedly')" key="3" value="2021101"></el-option>
          </el-select>
        </el-form-item>
        <!-- 税收商品名称 -->
        <el-form-item label="税收商品名称" prop="feeProductId">
          <el-select
            class="select"
            v-model="diaForm.feeProductId"
            placeholder="请选择税收商品名称"
          >
            <el-option
              key="0"
              label="请选择税收商品名称"
              value
            ></el-option>
            <el-option
              v-for="item in taxProductList"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('lang.lab_feeClassify')" prop="feeClassify" v-if="diaForm.feeTypeCd=='888800010001'">
          <el-radio-group v-model="diaForm.feeClassify">
            <el-radio 
              v-for="(item) in feeClassifyRoomList"
              :key="item.id"
              :value="item.id"
              :label="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="$t('lang.lab_updateLift')"  v-if="diaForm.feeTypeCd=='888800010001'">
          <el-radio-group v-model="diaForm.isUpdateLift">
            <el-radio 
              v-for="item in isFeeManagerList"
              :key="item.id"
              :value="item.id"
              :label="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_mobileShow')" prop="feeMobileShow">
          <el-radio-group v-model="diaForm.isMobileShow">
            <el-radio 
              v-for="item in isFeeManagerList"
              :key="item.id"
              :value="item.id"
              :label="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_feeClassify')" prop="feeClassify" v-if="diaForm.feeTypeCd=='888800010009'">
          <el-radio-group v-model="diaForm.feeClassify">
            <el-radio 
              v-for="item in feeClassifyCarList"
              :key="item.id"
              :value="item.id"
              :label="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 付费类型 -->
        <!-- <el-form-item :label="$t('lang.lab_paymentCd')" prop="paymentCd">
          <el-select
            class="select"
            v-model="diaForm.paymentCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_paymentCd')"
          >
            <el-option key="0" :label="$t('lang.lab_please_Select')+$t('lang.lab_paymentCd')" value></el-option>
            <el-option :label="$t('lang.prepaid')" key="1" value="1200"></el-option>
            <el-option :label="$t('lang.postpaid')" key="2" value="2100"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 缴费周期 -->
        <!-- <el-form-item :label="$t('lang.lab_paymentCycle')" prop="paymentCycle" v-if="diaForm.feeFlag=='1003006'">
          <el-input
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_paymentCycle')"
            v-model="diaForm.paymentCycle"
          ></el-input>
        </el-form-item> -->
        <!-- 账单周期 -->
        <!-- <el-form-item :label="$t('lang.lab_billTypeName')" prop="billType">
          <el-select
            class="select"
            v-model="diaForm.billType"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_billTypeName')"
          >
            <el-option
              key="0"
              :label="$t('lang.lab_please_Select')+$t('lang.lab_billTypeName')"
              value
            ></el-option>
            <el-option :label="$t('lang.year')" key="1" value="001"></el-option>
            <el-option :label="$t('lang.month')" key="2" value="002"></el-option>
            <el-option :label="$t('lang.day')" key="3" value="003"></el-option>
          </el-select>
        </el-form-item> -->
        <!--  计费起始时间 -->
        <el-form-item
          class="nextPMTime"
          :label="$t('lang.lab_startTime')"
          prop="startTime"
        >
          <el-date-picker
            v-model="diaForm.startTime"
            type="datetime"
            value-format="timestamp"
            :placeholder="$t('lang.plh.sel') + $t('lang.lab_startTime')"
          ></el-date-picker>
        </el-form-item>
        <!-- 计费结束时间 -->
        <el-form-item
          class="nextPMTime"
          :label="$t('lang.lab_endTimes')"
          prop="endTime"
        >
          <el-date-picker
            v-model="diaForm.endTime"
            type="datetime"
            value-format="timestamp"
            :placeholder="$t('lang.plh.sel') + $t('lang.lab_endTimes')"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_cycle')" prop="feeBase" v-if="diaForm.feeFlag == '1003006'">
          <el-input-number :placeholder="$t('lang.lab_feeBase')"
            :label="$t('lang.lab_AdverSortText')" v-model="diaForm.feeCycle" controls-position="right"
            :min="1" :max="12"></el-input-number>
        </el-form-item>
        <!-- 计费公式 -->
        <el-form-item :label="$t('lang.lab_computingFormula')" prop="computingFormula">
          <el-select
            v-model="diaForm.computingFormula"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_computingFormula')"
            class="select"
          >
            <el-option
              key="0"
              :label="$t('lang.lab_please_Select')+$t('lang.lab_computingFormula')"
              value
            ></el-option>
            <el-option
              v-for="item in feeFormulaList"
              :key="item.status_cd"
              :label="item.name"
              :value="item.status_cd"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 计费单价 -->
        <el-form-item
          :label="$t('lang.lab_squarePrice')"
          prop="squarePrice"
          v-if="diaForm.computingFormula != '2002'"
        >
          <el-input
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_squarePrice')"
            v-model="diaForm.squarePrice"
          ></el-input>
        </el-form-item>
        <!-- 附加费用/固定费用 -->
        <el-form-item
          :label="diaForm.computingFormula == '1001' ?$t('lang.lab_additionalAmount1'):$t('lang.lab_additionalAmount2')"
          prop="additionalAmount"
        >
          <el-input
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_additionalAmount')"
            v-model="diaForm.additionalAmount"
          />
        </el-form-item>
        <!-- 折扣率（0-1） -->
        <el-form-item
          label="折扣率"
          prop="discountRate"
        >
          <el-input
            placeholder="请输入折扣率（0-1）"
            v-model="diaForm.discountRate"
          />
        </el-form-item>
        <!-- 折扣时间（仅年份） -->
        <el-form-item label="折扣年份" prop="discountTime">
          <el-date-picker
            v-model="diaForm.discountTime"
            type="year"
            placeholder="请选择年份"
            value-format="yyyy"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <!--保存-->
        <el-button
          type="primary"
          @click="save('diaForm')"
          :disabled="isDisabled"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:feeConfigList 门禁设备管理
 *@Description:收费设置
 *@author:xubz
 *@Copyright:格众科技
 *@date:2020-11-30
 */
export default {
  name: '/manage/main.feeConfig',
  data() {
    var chooseGardenId = (rule, value, callback) => {
      if (this.diaForm.gardenId === '') {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.diaFormgardenId')
          )
        )
      } else {
        callback()
      }
    }
    // 折扣率校验：允许空；如有值，必须是 0~1 的数字
    var validateDiscountRate = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback()
        return
      }
      let num = parseFloat(value)
      if (isNaN(num)) {
        callback(new Error('折扣率必须是数字'))
      } else if (num < 0) {
        callback(new Error('折扣率不能小于0'))
      } else if (num > 1) {
        callback(new Error('折扣率不能大于1'))
      } else {
        callback()
      }
    }
    return {
      isFeeManagerList: this.$i18n.t('lang.AdminStrators.isFeeManagerList'), 
      isFeeManager: 0,
      zero: 0, // 值为0的变量
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      title: '', // 弹框显示的标题
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      types: [], // 小区下拉
      houseId: 0, // 楼号ID
      unitId: 0, // 单元号ID
      houseList: [], // 楼号列表
      unitList: [], // 单元号列表
      tableData: [], // 列表数组
      searchFeeName: '', // 搜索的关键字
      disabled: true,
      editId: '', // 编辑按钮保存的id
      isPopupPage: false, // 弹框的显示控制
      gardenDialist: [], // 弹框的小区列表
      houseDialist: [], // 弹框的楼号列表
      unitDialist: [], // 弹框的单元列表
      saveData: '', // 存储json字符串
      diaForm: {
        feeCycle: '3',
        isUpdateLift:0,
        gardenId: '',
        feeTypeCd: '',
        nccCode: '',
        feeName: '',
        feeFlag: '1003006',
        paymentCd: '1200',
        paymentCycle: '',
        billTypeName: '',
        billType: '',
        startTime: '',
        endTime: '',
        computingFormula: '',
        squarePrice: '',
        additionalAmount: '',
        feeClassify: '',
        isMobileShow:0,
        discountRate: 0,
        discountTime: null,
        feeProductId: ''
      },
      taxProductList: [], // 税收商品列表
      rules: {
        doorName: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_EquipmentName'),
            trigger: 'blur',
          },
        ],
        feeName: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_feeName'),
            trigger: 'blur',
          },
        ],
        feeTypeCd: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_feeTypeCdName'),
            trigger: 'blur',
          },
        ],
        gardenFeeId: [
          {
            required: true,
            validator: chooseGardenId,
            trigger: 'change',
          },
        ],
        feeFlag: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_feeFlagName'),
            trigger: 'blur',
          },
        ],
        paymentCd: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_paymentCd'),
            trigger: 'blur',
          },
        ],
        paymentCycle: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_paymentCycle'),
            trigger: 'blur',
          },
        ],
        billType: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_billTypeName'),
            trigger: 'blur',
          },
        ],
        startTime: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_startTime'),
            trigger: 'blur',
          },
        ],
        endTime: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_endTimes'),
            trigger: 'blur',
          },
        ],
         computingFormula: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_computingFormula'),
            trigger: 'blur',
          },
        ],
         squarePrice: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_squarePrice'),
            trigger: 'blur',
          },
        ],
         additionalAmount: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_additionalAmount'),
            trigger: 'blur',
          },
        ],
         feeClassify: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_feeClassify'),
            trigger: 'blur',
          },
        ],
        feeProductId: [
          {
            required: true,
            message: '请选择税收商品名称',
            trigger: 'change',
          },
        ],
        // 折扣率校验（非必填，填了就必须合法）
        discountRate: [
          {
            validator: validateDiscountRate,
            trigger: 'blur',
          },
        ],
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      isDisabled: true, // 保存的可点击
      gardenId: 0, // 小区绑定的id
      // ---------------------
      isDefault: 0, //
      feeTypeList: [],
      feeFormulaList: [],
      feeClassifyRoomList: this.$i18n.t('lang.feeClassifyRoomList'),
      feeClassifyCarList: this.$i18n.t('lang.feeClassifyCarList'),
    }
  },
  created() {
    console.log(this.$store.getters)
		this.gardenId = this.$store.getters.gardenId
    this.isFeeManager = this.$store.getters.isFeeManager
    this.getGarden()
    this.getTablelist()
    this.feePropertyProductsAll()
  },
  watch: {
    diaForm: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule == this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/feeConfigManageList/?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&feeName=${this.searchFeeName}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            this.feeTypeList = res.feeTypes
            this.feeFormulaList = res.feeFormulas
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 弹框点击取消按钮
    clear(diaForm) {
			this.$refs[diaForm].resetFields()
      this.diaForm.gardenId = ''
      this.diaForm.feeTypeCd = ''
      this.diaForm.nccCode = ''
      this.diaForm.feeName = ''
      this.diaForm.feeFlag = ''
      this.diaForm.paymentCd = ''
      this.diaForm.paymentCycle = ''
      this.diaForm.billTypeName = ''
      this.diaForm.startTime = ''
      this.diaForm.endTime = ''
      this.diaForm.computingFormula = ''
      this.diaForm.squarePrice = ''
      this.diaForm.additionalAmount = ''
      this.diaForm.discountRate = 0
      this.diaForm.discountTime = null
      this.diaForm.feeProductId = ''
      setTimeout(() => {
        this.$refs[diaForm].clearValidate()
      }, 0)
    },
    getGarden() {

      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.types = myGardens
        this.gardenDialist = myGardens
      // this.$get(`/gardens`).then(
      //   (res) => {
      //     if (res && res.errCode === 0) {
      //       this.types = res.list
      //       this.gardenDialist = res.list
      //     }
      //   },
      //   (error) => {
      //     this.$message.error(error)
      //   }
      // )
    },
    // 添加
    add() {
      this.diaForm.gardenId = ''
      this.diaForm.feeTypeCd = ''
      this.diaForm.nccCode = ''
      this.diaForm.feeName = ''
      // this.diaForm.feeFlag = ''
      this.diaForm.paymentCd = ''
      this.diaForm.paymentCycle = ''
      this.diaForm.billTypeName = ''
      this.diaForm.startTime = ''
      this.diaForm.endTime = ''
      this.diaForm.computingFormula = ''
      this.diaForm.squarePrice = ''
      this.diaForm.additionalAmount = ''
      this.diaForm.discountRate = 0
      this.diaForm.discountTime = null
      this.diaForm.feeProductId = ''
      this.editId = ''
      this.diaForm.feeClassify = ''
      this.isDisabled = false
      this.isPopupPage = true

      this.title = this.$i18n.t('lang.lab_addfeeConfig')
      this.$nextTick(() => {
          this.$refs.diaForm.clearValidate()
      })
    },
    // 编辑收费设置项
    edit(row) {
      this.title = this.$i18n.t('lang.lab_editfeeConfig')
      this.editId = row.configId
      this.$get(`/feeConfigManageList/${this.editId}`).then(
        (res) => {
          if (res && res.errCode === 0) {
            this.diaForm = res.list
          console.log("22222222222222221111::::"+this.diaForm)
            if(res.list.feeCycle==null){
              this.$set(this.diaForm, 'feeCycle',3)
            }
            if(res.list.isMobileShow==null){
              this.$set(this.diaForm, 'isMobileShow',0)
            }
           
            this.saveData = JSON.stringify(this.diaForm)
            console.log(res)
          }
        },
        (error) => {
          this.$message.error(error)
        }
      )
      this.isPopupPage = true
    },
    // 添加/保存按下确定
    save(diaForm) {
      if (this.editId === '') {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            if (this.diaForm.computingFormula == '2002') {
              this.diaForm.squarePrice = '0.00'
            }
            if (this.diaForm.feeFlag == '2006012') {
              this.diaForm.paymentCycle = '1' 
            }
            if(this.diaForm.feeClassify == ''||this.diaForm.feeClassify =='undefined'){
                this.diaForm.feeClassify=this.diaForm.feeTypeCd
            }else if(this.diaForm.feeClassify=='888800010019'||this.diaForm.feeClassify=='888800010020'){
                this.diaForm.feeClassify='888800010018'
            }
            let params = {
              gardenId: this.diaForm.gardenId,
              feeTypeCd: this.diaForm.feeTypeCd,
              nccCode: this.diaForm.nccCode,
              feeName: this.diaForm.feeName,
              feeFlag: this.diaForm.feeFlag,
              paymentCd: this.diaForm.paymentCd,
              paymentCycle: this.diaForm.paymentCycle,
              billTypeName: this.diaForm.billTypeName,
              beginTs: this.diaForm.startTime,
              endTs: this.diaForm.endTime,
              computingFormula: this.diaForm.computingFormula,
              squarePrice: this.diaForm.squarePrice,
              additionalAmount: this.diaForm.additionalAmount,
              discountRate: this.diaForm.discountRate,
              discountTime: this.diaForm.discountTime ? (typeof this.diaForm.discountTime === 'string' ? parseInt(this.diaForm.discountTime, 10) : this.diaForm.discountTime) : null,
              feeClassify: this.diaForm.feeClassify,
              isUpdateLift:this.diaForm.isUpdateLift,
              isMobileShow:this.diaForm.isMobileShow,
              feeCycle:this.diaForm.feeCycle,
              feeProductId: this.diaForm.feeProductId
            }
            let loading = this.$loading()
            this.$post(`/saveFeeConfigManage`, params).then(
              (res) => {
                loading.close()
                // if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.isPopupPage = false
                this.commit()
                // }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      } else {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (this.diaForm.computingFormula == '2002') {
              this.diaForm.squarePrice = '0.00'
            }
            if (this.diaForm.feeFlag == '2006012') {
              this.diaForm.paymentCycle = '1'
            }
            console.log(this.diaForm.feeClassify)
            if(this.diaForm.feeTypeCd=='888800010001'||this.diaForm.feeTypeCd=='888800010009'||this.diaForm.feeTypeCd=='888800010010'){
              if(this.diaForm.feeClassify == ''||this.diaForm.feeClassify ==undefined||this.diaForm.feeClassify ==null){
                this.diaForm.feeClassify=this.diaForm.feeTypeCd
               }else if(this.diaForm.feeClassify=='888800010019'||this.diaForm.feeClassify=='888800010020'){
                this.diaForm.feeClassify='888800010018'
               }
            }else{
               this.diaForm.feeClassify=this.diaForm.feeTypeCd
            }
          
            let params = {
              gardenId: this.diaForm.gardenId,
              feeTypeCd: this.diaForm.feeTypeCd,
              nccCode: this.diaForm.nccCode,
              feeName: this.diaForm.feeName,
              feeFlag: this.diaForm.feeFlag,
              paymentCd: this.diaForm.paymentCd,
              paymentCycle: this.diaForm.paymentCycle,
              billTypeName: this.diaForm.billTypeName,
              beginTs: this.diaForm.startTime,
              endTs: this.diaForm.endTime,
              computingFormula: this.diaForm.computingFormula,
              squarePrice: this.diaForm.squarePrice,
              additionalAmount: this.diaForm.additionalAmount,
              discountRate: this.diaForm.discountRate,
              discountTime: this.diaForm.discountTime ? (typeof this.diaForm.discountTime === 'string' ? parseInt(this.diaForm.discountTime, 10) : this.diaForm.discountTime) : null,
              feeClassify: this.diaForm.feeClassify,
              isUpdateLift:this.diaForm.isUpdateLift,
              isMobileShow:this.diaForm.isMobileShow,
              feeCycle:this.diaForm.feeCycle,
              feeProductId: this.diaForm.feeProductId
            }
            this.$patch(`/updateFeeConfigManage/${this.editId}`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } else {
            return false
          }
        })
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.diaForm.resetFields()
      this.diaForm.unit = 0
      this.diaForm.house = 0
      this.diaForm.gardenId = ''
      this.diaForm.type = 1
      this.diaForm.name = ''
      this.diaForm.macName = ''
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 获取小区下的楼号
    getListHouse() {
      this.houseId = 0
      this.houseList = []
      this.unitId = 0
      this.unitList = []
      this.type = 1
      let loading = this.$loading()
      this.$get(
        `/gardenGrids?type=${this.type}&parentId=${this.gardenId}&pageNo=1&pageSize=999`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.houseList = res.list
            if (this.gardenId === 0) {
              this.houseId = 0
              this.houseList = []
              this.unitId = 0
              this.unitList = []
            }
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          // 添加del的url
          this.$delete(`/feeConfigManage/` + id).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success'),
                })
                this.commit()
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can'),
          })
        })
    },
    // 查询所有税收信息
    feePropertyProductsAll() {
      let loading = this.$loading()
      this.$get(`/feePropertyProductsAll`).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            // 将返回的数据转换为下拉选项格式
            // 接口返回的集合中，id（税收商品编码）为 key，productName（税收商品名称）为 value（显示名称）
            let productList = res.list || res.result || res.data || []
            this.taxProductList = productList.map(item => ({
              id: item.id,
              productName: item.productName
            }))
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
  },
}
</script>

<style lang="scss">
.nextPMTime label {
  width: 150px !important;
}

.el-dialog .el-form .el-form-item {
  margin-right: 0;
  margin-bottom: 15px !important;
  text-align: left;
}
</style>